import React from 'react';
import { Brain, Heart, Users } from 'lucide-react';

const SpecialtiesSection = () => {
  const specialties = [
    {
      icon: Brain,
      title: 'Ansiedade',
      description: 'Tratamento especializado para transtornos de ansiedade, ajudando você a recuperar o controle e a tranquilidade em sua vida.',
      color: 'blue'
    },
    {
      icon: Heart,
      title: 'Depressão',
      description: 'Acompanhamento terapêutico profundo para superar a depressão, resgatando sua energia vital e vontade de viver.',
      color: 'blue'
    },
    {
      icon: Users,
      title: 'Relacionamentos',
      description: 'Terapia especializada em relacionamentos e sexualidade, promovendo conexões mais saudáveis e autênticas.',
      color: 'blue'
    }
  ];

  return (
    <section id="especialidades" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">Especialidades</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Atendimento online especializado para transformar sua vida emocional
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {specialties.map((specialty, index) => {
              const Icon = specialty.icon;
              return (
                <div
                  key={index}
                  className="group bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-blue-100"
                >
                  <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-2xl font-bold text-blue-900 mb-4">{specialty.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{specialty.description}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 md:p-12 text-center shadow-xl">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Atendimento Online
            </h3>
            <p className="text-blue-100 text-lg mb-6 max-w-2xl mx-auto">
              Sessões de terapia no conforto da sua casa, com toda a privacidade e acolhimento que você merece.
            </p>
            <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full">
              <p className="text-white font-semibold">Consultas via videochamada</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialtiesSection;